import { DeleteIcon, IconBlockIcon } from '../../../editorjs/icons/icons';
import BtnTooltip from '../../tooltips/btnTooltip';
import { EdjsTooltips } from '../../tooltips/edjsTooltip';
import { processInitialPosition, getDraggableData } from '../../blockTunes/draggable/mediaUtils'

/**
 * Build styles
 */
require('./index.css').toString();

export default class Icon {

  static get toolbox() {
    return {
      icon: IconBlockIcon,
      title: 'Icon',
    };
  }

  static get isReadOnlySupported() {
    return true;
  }


  constructor({ data, config, api, readOnly }) {
    this.api = api;
    this.readOnly = readOnly;

    this._CSS = {
      baseClass: this.api.styles.block,
      loading: this.api.styles.loader,
      settingsButton: this.api.styles.settingsButton,
      settingsButtonActive: this.api.styles.settingsButtonActive,

      /**
       * Tool's classes
       */
      container: 'cdx-media-container',
      containerLoading: 'cdx-media-container-loading',
      loader: 'cdx-media-loader',
      wrapper: 'cdx-media-wrapper',
      btn: 'cdx-media-btn',
      replaceButton: 'replace-btn',
      removeButton: 'remove-btn',
      blockBtn: 'block-btn',
      blockBtnSmall: 'small',
      blockBtnLarge: 'large',
      largeIcon: 'large-icon',
      xlIcon: 'xl-icon',
      xxlIcon: 'xl-icon',
      smIcon: 'sm-icon',
      xsIcon: 'xs-icon',
      clear: 'clear',
      focusVisibleBtn: 'focus-visible-btn',
    };

    /**
      * Tool's settings passed from Editor
      *
      * @type {TitleConfig}
      * @private
      */
    this._settings = config;
    const _defaultContent = {
      name: "World outline",
      icon: '<svg width="100%" height="100%" viewBox="0 0 750 750" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><path id="_3---world-outline" serif:id="3 - world-outline" d="M406.847,601.053c12.239,-10.182 27.258,-24.183 42.346,-42.01c13.079,-15.456 27.185,-35.097 39.278,-58.669c27.862,7.847 48.216,16.84 60.052,22.786c-35.376,41.372 -85.25,69.98 -141.676,77.893m-205.747,-78.338c10.244,-5.954 28.249,-14.95 54.189,-22.75c12.14,23.752 26.332,43.535 39.487,59.078c14.529,17.171 28.987,30.777 40.968,40.853c-53.578,-9.324 -100.796,-37.394 -134.644,-77.181m132.272,-372.633c-11.738,10.09 -25.917,23.728 -40.165,40.945c-12.809,15.479 -26.622,35.159 -38.458,58.774c-25.997,-7.881 -43.992,-16.935 -54.108,-22.827c33.409,-39.654 79.946,-67.612 132.731,-76.892m214.644,77.011c-11.826,5.906 -31.793,14.678 -58.964,22.373c-11.798,-23.47 -25.545,-43.032 -38.291,-58.439c-14.348,-17.335 -28.624,-31.044 -40.41,-41.152c54.78,9.064 103.087,37.192 137.665,77.218m-29.063,139.463c-1.161,-38.652 -10.176,-72.583 -22.6,-101.429c29.559,-8.562 50.703,-18.32 62.489,-24.504c26.354,35.6 42.527,78.975 44.267,125.933l-84.156,0Zm-0.004,16.888l84.162,0c-1.72,47.054 -17.744,90.513 -43.85,126.154c-11.758,-6.199 -33.199,-16.159 -63.347,-24.855c12.666,-28.819 21.854,-62.707 23.035,-101.299m-138.521,84.142l0,-84.142l121.615,0c-1.197,36.651 -10.084,68.996 -22.742,96.878c-27.357,-6.674 -60.498,-11.868 -98.873,-12.736m0,16.9c35.011,0.838 65.57,5.501 91.126,11.526c-29.387,55.03 -72.005,90.182 -91.126,104.097l0,-115.623Zm-16.892,-0.074l0,115.717c-19.204,-13.941 -62.116,-49.257 -91.512,-104.707c24.741,-6.054 55.216,-10.581 91.512,-11.01m-121.615,-100.968l121.615,0l0,84.078c-39.6,0.447 -72.601,5.539 -99.156,12.295c-12.508,-27.752 -21.272,-59.926 -22.459,-96.373m-16.904,0c1.178,38.451 10.3,72.234 22.894,100.986c-27.754,8.56 -46.787,18.456 -57.396,24.861c-25.974,-35.584 -41.912,-78.929 -43.628,-125.847l78.13,0Zm-0.002,-16.888l-78.13,0c1.698,-47.028 17.494,-90.463 43.227,-126.094c10.469,6.363 29.48,16.325 57.366,24.97c-12.355,28.78 -21.309,62.608 -22.463,101.124m138.521,-84.078l0,84.078l-121.617,0c1.163,-36.475 9.767,-68.689 22.042,-96.479c26.625,6.81 59.768,11.952 99.575,12.401m0,-16.89c-36.499,-0.435 -67.162,-5.056 -92.035,-11.201c30.222,-58.144 74.938,-94.187 92.035,-106.535l0,117.736Zm16.892,-0.074l0,-117.666c17.046,12.312 61.534,48.171 91.748,105.992c-25.679,6.099 -56.456,10.828 -91.748,11.674m0,16.898c38.598,-0.87 71.895,-6.123 99.344,-12.853c12.397,27.909 21.104,60.294 22.275,96.997l-121.619,0l0,-84.144Zm169.775,-84.254c-47.998,-47.176 -111.294,-73.158 -178.221,-73.158c-66.628,0 -128.896,26.03 -175.335,73.292c-46.2,47.022 -71.646,109.779 -71.646,176.708c0,137.85 112.15,250 249.998,250c137.85,0 250,-112.15 250,-250c0,-66.63 -26.565,-129.434 -74.796,-176.842" style="fill:currentColor;fill-rule:nonzero;"></path></svg>',
      color: "#000000",
    }
    this._data = {
      name: data.name || this._settings?.defaultContent?.name || _defaultContent.name || '',
      icon: data.icon || this._settings?.defaultContent?.icon || _defaultContent.icon || '',
      color: data.color || _defaultContent.color || '#222',
      tuneData: {
        top: data?.tuneData?.top || '',
        left: data?.tuneData?.left || '',
        width: data?.tuneData?.width || '',
        height: data?.tuneData?.height || '',
      },
    };

    this._element = this.getElement();
  }

  getElement() {
    let div;

    if (this._data.icon) {
      div = document.createElement('div');
      div.classList.add(this._CSS.wrapper);
      div.innerHTML = this._data.icon;
      div.setAttribute('data-name', this._data.name);
      div.setAttribute('data-color', this._data.color);
      div.style.color = this._data.color;
    }

    return div;
  }

  render() {
    this.container = document.createElement('div');
    this.container.classList.add(this._CSS.container);
    this.container.classList.add(this._CSS.containerLoading);
    let div = this._element;

    // hidden input hack
    // prevents empty blocks being created
    const hiddenInput = document.createElement("input");
    hiddenInput.setAttribute(
      "style",
      "visibility: hidden; width: 0; height: 0; padding: 0; margin: 0; border: 0; position: absolute",
    );
    this.container.appendChild(hiddenInput);

    if (this._settings.loader) {
      let loader = document.createElement('div');
      loader.classList.add(this._CSS.loader);
      loader.appendChild(this._settings.loader);

      this.container.appendChild(loader);
    }

    if (!this.readOnly) {
      let btn = document.createElement('button');
      let btnRemove = document.createElement('button');
      BtnTooltip(btn, EdjsTooltips.icon.main);
      BtnTooltip(btnRemove, EdjsTooltips.icon.remove);

      if (this._data.icon) {
        btn.classList.add(this._CSS.blockBtn, this._CSS.blockBtnSmall, this._CSS.xxlIcon, this._CSS.focusVisibleBtn);
        btn.innerHTML = `${Icon.toolbox.icon}`;
        btnRemove.classList.add(this._CSS.blockBtn, this._CSS.blockBtnSmall, this._CSS.clear, this._CSS.xlIcon, this._CSS.focusVisibleBtn);
        btnRemove.innerHTML = `${DeleteIcon}`;
      } else {
        // btn.classList.add(this._CSS.btn);
        btn.classList.add(this._CSS.blockBtn, this._CSS.blockBtnSmall, this._CSS.xxlIcon, this._CSS.focusVisibleBtn);
        btn.innerHTML = `${Icon.toolbox.icon}`;
      }

      btn.onclick = () => {
        const blockIndex = this.api.blocks.getCurrentBlockIndex();
        const block = this.api.blocks.getBlockByIndex(blockIndex);
        if (this._settings.draggable) {
          this._settings.showIconSelector({
            details: block,
            data: getDraggableData(this._data, this.container, '.icon'),
          });
        } else {
          this._settings.showIconSelector({
            details: block,
            data: this._data,
          });
        }
      };

      btnRemove.onclick = () => {
        this._data.icon = '';
        this._data.name = '';
        this._data.color = '#222';
        this._element.remove();
        btnRemove.remove();
      }

      if (typeof div !== 'undefined') {
        this.container.appendChild(div);
        this.container.appendChild(btn);
        this.container.appendChild(btnRemove);
      } else {
        // hidden input hack
        // prevents empty blocks being created
        let input = document.createElement('input');
        input.setAttribute('style', 'visibility: hidden; width: 0; height: 0; padding: 0; margin: 0; border: 0; position: absolute');

        this.container.appendChild(input);
        this.container.appendChild(btn);
      }
    } else {
      if (typeof div !== 'undefined') {
        this.container.appendChild(div);
      }
    }

    // this.setDraggablePosition();
    this.container.classList.remove(this._CSS.containerLoading);
    return this.container;
  }

  setDraggablePosition() {
    const loadingClass = this._CSS.containerLoading;

    if (this._settings.draggable && (this._data.tuneData.top !== '')) {
      setTimeout(() => {
        processInitialPosition(this._data, this.container, '.icon');
        this.container.classList.remove(loadingClass);
      }, 1000)
    } else {
      this.container.classList.remove(loadingClass);
    }
  }

  rendered() {
    // this.setDraggablePosition();
    const loadingClass = this._CSS.containerLoading;
    this.container.classList.remove(loadingClass);
  }

  save() {
    if (typeof this._element !== 'undefined') {
      this._data.icon = this._element.innerHTML || '';
      this._data.name = this._element.getAttribute('data-name') || '';
      this._data.color = this._element.getAttribute('data-color') || '#222';
    } else {
      this._data.icon = '';
      this._data.name = '';
      this._data.color = '#222';
    }

    if (this._settings.draggable && this.container) {
      return getDraggableData(this._data, this.container, '.icon');
    } else {
      return this._data;
    }
  }
}